// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel {
    'value': string;
    'isPreferred': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel>> = [
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "isPreferred",
            "baseName": "isPreferred",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.attributeTypeMap;
    }
}
